var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30.7,42c0,6.1,12.6,7,12.6,22c0,11-7.9,19.2-18.9,19.2C12.7,83.1,5,72.6,5,61.5c0-19.2,18-44.6,29.2-44.6  c2.8,0,7.9,2,7.9,5.4S30.7,31.6,30.7,42z","key":0}),React.createElement("path",{"d":"M82.4,42c0,6.1,12.6,7,12.6,22c0,11-7.9,19.2-18.9,19.2c-11.8,0-19.5-10.5-19.5-21.6c0-19.2,18-44.6,29.2-44.6  c2.8,0,7.9,2,7.9,5.4S82.4,31.6,82.4,42z","key":1})]);
}

Quote.defaultProps = {"height":"100px","width":"100px","fill":"#000000","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = Quote;

Quote.default = Quote;
